import React, { memo, useCallback } from "react";
import { NodeProps } from "reactflow";
import { useUpdateNodeData } from "../../../hooks/useUpdateNodeData";
import { NodeType } from "../../../models/nodeType";
import SelectSkill from "../../base/SelectSkill";
import BaseNode from "../../../features/reactflow/nodes/base/BaseNode";

interface SkillData {
  skillId: string;
}

const PlayerCurrentSkillLevelNode: React.FC<NodeProps<NodeType>> = (props) => {
  const {
    id: nodeId,
    data: { color, nodeData: skill },
  } = props;

  const { updateNodeData } = useUpdateNodeData<SkillData>(nodeId);

  const handleUpdateSkill = useCallback(
    (skillId: string) => {
      updateNodeData({
        skillId,
      });
    },
    [updateNodeData]
  );

  const skillId = skill?.skillId ?? "";

  return (
    <BaseNode {...props}>
      <SelectSkill color={color} value={skillId} setValue={handleUpdateSkill} />
    </BaseNode>
  );
};

export default memo(PlayerCurrentSkillLevelNode);
